import {
  AUTO_SELECT_SCENARIOS_ASYNC,
  CHANGE_ATTACK_VECTOR,
  CHANGE_CREATED_BY_FILTER,
  CHANGE_LEVEL_FILTER,
  CHANGE_LOCALES,
  CHANGE_SORT_OPTION,
  CHANGE_TYPE_FILTER,
  FETCH_CATEGORIES_ASYNC,
  PICK_CATEGORY,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_IS_VISITED,
} from './constants'

const fetchCategories = () => ({ type: FETCH_CATEGORIES_ASYNC.INITIATE })
export const fetchCategoriesSuccess = (data) => ({
  type: FETCH_CATEGORIES_ASYNC.SUCCESS,
  payload: { data },
})
const fetchCategoriesCancel = () => ({ type: FETCH_CATEGORIES_ASYNC.CANCEL })
export const fetchCategoriesError = (error) => ({
  type: FETCH_CATEGORIES_ASYNC.ERROR,
  error,
})

const autoSelectScenarios = (type) => ({
  type: AUTO_SELECT_SCENARIOS_ASYNC.INITIATE,
  payload: { type },
})
export const autoSelectScenariosSuccess = (type, data) => ({
  type: AUTO_SELECT_SCENARIOS_ASYNC.SUCCESS,
  payload: { type, data },
})
const autoSelectScenariosCancel = () => ({
  type: AUTO_SELECT_SCENARIOS_ASYNC.CANCEL,
})
export const autoSelectScenariosError = (error) => ({
  type: AUTO_SELECT_SCENARIOS_ASYNC.ERROR,
  error,
})

const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })
const changeSortOption = (value, isFetchCategories) => ({
  type: CHANGE_SORT_OPTION,
  payload: { value, isFetchCategories },
})
const changeLevelFilter = (value) => ({
  type: CHANGE_LEVEL_FILTER,
  payload: { value },
})
const changeTypeFilter = (value) => ({
  type: CHANGE_TYPE_FILTER,
  payload: { value },
})
const changeCreatedByFilter = (array) => ({
  type: CHANGE_CREATED_BY_FILTER,
  payload: { array },
})
const pickCategory = (categoryId) => ({
  type: PICK_CATEGORY,
  payload: { categoryId },
})
export const changeScenarioLocales = (value) => ({
  type: CHANGE_LOCALES,
  payload: { value },
})
const setIsVisited = (value) => ({
  type: SET_IS_VISITED,
  payload: { value },
})

export default {
  // to props
  fetchCategoriesCancel,
  autoSelectScenarios,
  autoSelectScenariosCancel,
  searchChange,
  searchReset,
  changeSortOption,
  changeLevelFilter,
  changeTypeFilter,
  changeAttackVector: (value) => ({ type: CHANGE_ATTACK_VECTOR, payload: { value } }),
  changeCreatedByFilter,
  pickCategory,
  fetchCategories,
  changeScenarioLocales,
  setIsVisited,
}
